import { api } from '@/api'
import { BaseApi } from '@/api/BaseApi.ts'
import type {
  InitiativeCreatePermission,
  InitiativeData,
  InitiativeFetchParams,
  InitiativeFormData,
  InitiativeFullData,
  InitiativeSearchParams,
  InitiativeSearchResult,
} from '@/api/Initiative/types.ts'
import type { FetchParams, Paginated, ParamType } from '@/api/types.ts'
import type { UserData } from '@/api/User/types.ts'

class Api extends BaseApi<
  InitiativeFullData,
  Paginated<InitiativeData>,
  InitiativeFormData,
  InitiativeFetchParams
> {
  readonly baseUrl = '/initiatives'

  async fetchAdminUsers(
    params: ParamType[],
    fetchParams: FetchParams
  ): Promise<Paginated<UserData>> {
    const URParams = new URLSearchParams(this.buildFetchParams(fetchParams))
    const url = `${this.getBaseUrl(this.baseUrl + '/:initiativeId/admin-users', params)}?${URParams.toString()}`
    const { data } = await api.get<Paginated<UserData>>(url, this.config)
    return data
  }

  async createPermission(
    params: ParamType[],
    payload: InitiativeCreatePermission
  ): Promise<void> {
    const url = `${this.getBaseUrl(this.baseUrl + '/:initiativeId/admin-users', params)}`
    const { data } = await api.post<void>(url, payload, this.config)
    return data
  }

  async removeAdminUser(params: ParamType[] = []): Promise<void> {
    const url = `${this.getBaseUrl(this.baseUrl + '/:initiativeId/admin-users/:userId', params)}`
    const { data } = await api.delete<void>(url, this.config)
    return data
  }

  async duplicateInitiative(
    params: ParamType[],
    payload: InitiativeFormData
  ): Promise<void> {
    const url = `${this.getBaseUrl(this.baseUrl + '/:initiativeId/duplicate', params)}`
    const { data } = await api.post<void>(url, payload, this.config)
    return data
  }

  async search(
    params: ParamType[],
    searchParams: InitiativeSearchParams
  ): Promise<InitiativeSearchResult[]> {
    const queryParams = new URLSearchParams(this.buildFetchParams(searchParams))
    const url = `${this.getBaseUrl(this.baseUrl + '/:initiativeId/search', params)}?${queryParams.toString()}`
    const { data } = await api.get<InitiativeSearchResult[]>(url, this.config)
    return data
  }
}

const InitiativeApi = new Api()

export default InitiativeApi
